import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../i18n/it";
import moment from "moment/moment";
import { UtilsService } from "../../../../auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-option-report-unlock-day",
  templateUrl: "./configuration-report-unlock-day.component.html",
  styleUrls: ["./configuration-report-unlock-day.component.scss"],
})
export class ConfigurationReportUnlockDayComponent implements OnInit {
  public contentHeader: IContentHeader;

  public user_report_max_day: any = {};

  public monthsNumber: any = Array.from({ length: 12 }, (_, i) => i);

  constructor(public _utilService: UtilsService) {
    this._utilService.disableAutoHideLoading();
  }

  ngOnInit(): void {
    this.user_report_max_day = JSON.parse(JSON.stringify(this._utilService.themeConfiguration.user_report_max_day));

    for (let number of Object.keys(this.user_report_max_day)) {
      this.user_report_max_day[number] = this.user_report_max_day[number] === 0 ? null : this.user_report_max_day[number];
    }

    this.contentHeader = {
      headerTitle: italian.data.CONFIGURATIONS.MANAGE_REPORT_UNLOCK_DAY,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.CONFIGURATIONS.CONFIGURATIONS,
            isLink: true,
            link: "/dashboard/configurations",
          },
          {
            name: italian.data.CONFIGURATIONS.MANAGE_REPORT_UNLOCK_DAY,
            isLink: false,
          },
        ],
      },
    };

    setTimeout(() => this._utilService.hideLoading());
  }

  monthName(n: number) {
    moment.locale("it");
    return moment().month(n).format("MMMM");
  }

  save() {
    const data: any = JSON.parse(JSON.stringify(this.user_report_max_day));

    for (let number of Object.keys(data)) {
      if (data[number] === null) {
        data[number] = 0;
      }
    }

    return this._utilService.updateOption("user_report_max_day", data);
  }
}
